module.exports = __webpack_public_path__ + "img/cqebc.f3b06eb4.jpg";